import moment from 'moment';
import momentTime from "moment-timezone";
import { LOGIN_ROOT } from '../service/apiUrls';
import { authTokenCookie } from '../utils/CookieMaker';
import store from '../redux/store/index';
import { setAPIMKey,setUserSFKeyMap } from 'component/screens/customerComments/customerCommentsAction';
export const logout = () => {
  sessionStorage.clear();
  let { userInfo} = authTokenCookie();
  sessionStorage.setItem("sessionId", userInfo.userId)
  clearRedux('logout');
  document.cookie.split(";").map(cookies => {
    document.cookie = cookies.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    return cookies;
});
  let url = LOGIN_ROOT.substring(0,LOGIN_ROOT.length)

  window.location.replace(`${url}/azurelogout`);
}

export const serverlogout = () => {
  sessionStorage.clear();
  let { userInfo} = authTokenCookie();
  sessionStorage.setItem("sessionId", userInfo.userId)
  clearRedux('logout');
  //localStorage.clear();
  let url = LOGIN_ROOT.substring(0,LOGIN_ROOT.length)

  window.location.replace(`${url}/loginError`);
}
export const fileNameBuilder = (obj) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === "") {
      delete obj[key];
    }
  });
  let query = ""
  for (let d in obj){
     query += obj[d] + '_'
  }
  return query.slice(0, -1)
}
export const queryBuilder = (obj) => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === "") {
      delete obj[key];
    }
  });
  let query = "?"
  for (let d in obj)
     query += d + '=' + obj[d] + '&'
  return query.slice(0, -1)
}

export const clearRedux =(checkLogout)=>{
  let state=store.getState();
  if(checkLogout !== 'logout'){
    const key=state.closeTheLoop.key;
    const mapKey=state.closeTheLoop.userSFMap;
    store.dispatch({ type: 'CLEAR_STORE', value:null });
    store.dispatch(setAPIMKey(key));
    store.dispatch(setUserSFKeyMap(mapKey));
  }
  else {
    store.dispatch({ type: 'CLEAR_STORE', value:null });
    localStorage.clear();
  }
}

export const clearState=(storeToClear)=> {
store.dispatch({ type: storeToClear, value: null });     
}


export const getUserID = () => {
  let { userInfo } = authTokenCookie();
  return userInfo.userId;
};

export const convertToMST = (date) => {
  return momentTime(new Date(date)).tz('America/Denver').format('YYYY-MM-DD');;
}
export const formSelectData = (placeholder, data) => {
  let tempData = [{ label: placeholder, value: placeholder }]
  data.forEach((item) => {
    let tmpObj = {
      label: item.value,
      value: item.id,
    }
    tempData = [...tempData, tmpObj]
  })
  return tempData;
}

export const formAutoCompleteData = (placeholder, data) => {
  let tempData = [{ title: placeholder, value: placeholder }]
  data.forEach((item) => {
    let tmpObj = {
      title: item.value,
      value: item.id
    }
    tempData = [...tempData, tmpObj]
  })
  return tempData;
}

export const caseIdFormData = (data) => {
  const records = data.customerServiceRecords[0];
  let closeDate = (records.closedDate ==="NA" || records.closedDate ==="") ? records.closedDate : moment(records.closedDate).format("MM/DD/YYYY")
  let closeBy = `SAFEWAY\\${records.closedBy?records.closedBy.toUpperCase():""}`
  let caseObject = modifyCases(records.cases)
  let tempObj = {
    caseId: records.caseNumber,
    openDate: moment(records.createdDate).format("MM/DD/YYYY"),
    closedDate: (records.autoClosed && !records.isClosed)?'Auto-Closed':closeDate,
    closedBy: (records.autoClosed && !records.isClosed)?'Auto-Closed':closeBy,
    openDays:records.openDays,
    customerName: `${records.contactName.FirstName} ${records.contactName.LastName}` ,
    phone: phoneNumberFormatter(records.contactPhone),
    email: records.contactEmail,
    contactStatus: !records.autoClosed ? (records.status === 'CLOSED'? 'Closed': 'Open') : "Closed",
    cases : caseObject.caseArray,
    nonCtlOpen: caseObject.nonCtlOpen,
    autoClosed: records.autoClosed,
    firstAttempt: {
      date: '',
      name: '',
      position: '',
      result: ''
    },
    secondAttempt: {
      date: '',
      name: '',
      position: '',
      result: ''
    },
    thirdAttempt: {
      date: '',
      name: '',
      position: '',
      result: ''
    },
    issueResolved: records.isssueResolved?"yes":"no",
    custReach: records.customerReachable?'yes':'no',
    conversation: records.conversationWithCustomer,
    recognition: records.employeeRecognitionOrCoaching,
    resolve: records.stepToResolveIssue,
    isCTLCloseAndNonCTLOpen: records.ctlcloseAndNonCTLOpen
  }

  if(records.noOfAttempts>0){
    records.attempts.forEach((item) => {
      if(item.attemptNbr===1){
        tempObj.firstAttempt.date = item.date
        tempObj.firstAttempt.position = item.position
        tempObj.firstAttempt.result = item.contactResult
        tempObj.firstAttempt.name = item.callerName
      }
      if(item.attemptNbr===2){
        tempObj.secondAttempt.date = item.date
        tempObj.secondAttempt.position = item.position
        tempObj.secondAttempt.result = item.contactResult
        tempObj.secondAttempt.name = item.callerName
      }
      if(item.attemptNbr===3){
        tempObj.thirdAttempt.date = item.date
        tempObj.thirdAttempt.position = item.position
        tempObj.thirdAttempt.result = item.contactResult
        tempObj.thirdAttempt.name = item.callerName
      }
    })
  }
  return tempObj;
}

export const modifyCases = (data) => {
  let caseArr = []
  let caseArrObj = {}
  if (data) {
    let rec = data ? data.comments : []
    rec.forEach((item) => {
      if(item.recordType === 'Close the Loop'){
        const dateFormatted = item.commentDate?item.commentDate.split(" "):"";
        let tempObj = {
          number: item.caseNumber,
          date: dateFormatted?`${moment(dateFormatted[0]).format("MM/DD/YYYY")} ${dateFormatted[1]}`:'',
          storeNum: item.storeNbr,
          location: item.location,
          caseDes: item.description,
          caseSub: item.subject,
          caseStatus: item.isClosed ? "Closed" : (item.autoClosed?"Auto-Closed":"Open")
        }
        caseArr.push(tempObj)
      }
      else {
        if(!item.isClosed){
          caseArrObj.nonCtlOpen = true          
        }

        }
    })
    // if (data.totalSize === caseArr.length)
    caseArrObj.caseArray = caseArr
      return caseArrObj;
  }else
  return caseArrObj
}

export const phoneNumberFormatter = (phone) => {
  if (phone) {
    let phnNum = phone.toString()
    return `(${phnNum.slice(0, 3)})-${phnNum.slice(3, 6)}-${phnNum.slice(6)}`;
  }
}

export const getToken = (role) => {
  let tokenObj = {
    'Division User': '',
    'District User': '',
    'Store User': '',
    'Backstage Non CSC User': ''
  }
  let keys = Object.keys(tokenObj)
  let token = ''
  keys.forEach((item) => {
    if (role === item)
      token = tokenObj[item]
  })
  return token
}


export const formatDetails = (userArray, status) => {
  let details= {
    districtId: "",
    districtName: "",
    district: [],
    store: [],
    divisionId: "",
    divisionName: "",
    storeId: "",
    storeName: "",
    status:status
}
  userArray.forEach((item) => {
    if(item.divisionId){
      details.divisionId = item.divisionId
      details.divisionName = item.divisionName
    }
    if(item.districtId){
      // let disObj = {value: item.districtId, title: item.districtNbr}
      details.districtId = item.districtId
      details.districtName = item.districtNbr
      // details.district.push(disObj)
    }
    if(item.storeId){
      // let storeObj = { value: item.storeId, title: item.storeName }
      details.storeId = item.storeId
      details.storeName = item.storeName
      // details.store.push(storeObj)
    }
  })
  return details
}

export const hasWhiteSpace = (val) => {
  return /^\s|\s$/.test(val);
}
export const appendZeros = (val, maxLength, minLength) => {
  let appendedVal = val
  let valLen = val ? val.length : 0
  if (val && valLen >= minLength) {
    let appendZero = ``
    let zerosToBeAppended = maxLength - valLen
    if (zerosToBeAppended > 0) {
      for (let i = 0; i < zerosToBeAppended; i++) {
        appendZero = `${appendZero}0`
      }
      appendedVal = `${appendZero}${appendedVal}`
    }
  }
  return appendedVal
}